// Get the browser locale, forcing a format like `en-US` because some browsers produce an all-lowercase value.
export const getNormalizedLocale = (locale = navigator.language) => {
  const parts = locale.split('-');
  parts[0] = parts[0].toLowerCase();
  if (parts.length === 2) {
    parts[1] = parts[1].toUpperCase();
  }
  return parts.join('-');
};
